import { AiseaApiFactory } from "@/api/aisea/apiFactory";
const EnterpriseUser = AiseaApiFactory.get("enterpriseUser");

export default {
  async fetchUsers({ commit }, request) {
    let response = await EnterpriseUser.search(request);
    commit("SET_USERS", response.data.users);
    commit("SET_PAGING", response.data.pageable);
  },
  fetchUser({ commit }, userId) {
    return new Promise((resolve, reject) => {
      EnterpriseUser.fetch(userId)
        .then(response => {

          commit("SET_USER", response.data);
          //commit("SET_LICENSE_DATA", response.data.license);
          return resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  addUser(_, request) {
    return new Promise((resolve, reject) => {
      EnterpriseUser.add(request)
        .then(response => {
          return resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  saveChanges({ commit }, request) {
    return new Promise((resolve, reject) => {
      EnterpriseUser.save(request)
        .then(response => {
          commit("SET_USER", response.data);
          return resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};
